export function normalizeTelemetry(raw) {
    if (!Array.isArray(raw)) return [];
    return raw.map(row => ({
        id: row.id,
        message_timestamp: row.messageTimestamp,   
        parameter_id: row.parameterId,
        parameter_value: row.parameterValue,
        trem_id: row.tremId,
        carro: row.carro,
        category: row.category,
        batch_id: row.batchId,
        batch_timestamp: row.batchTimestamp,
        publisher_id: row.publisherId,
        created_at: row.createdAt
    }));
}
